















import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { formatCurrency } from '@getaccept/lib-shared/src/helpers/currency';
import type { Currency } from '@getaccept/lib-shared/src/types/Currency';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { DashboardWidgetHeaderColor } from '../../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../../types/enums/dashboard-widget-value-color';
import DashboardWidget from '../DashboardWidget.vue';
import type { DashboardWidgetData } from '../../types/dashboard-widget-data';

export default defineComponent({
  name: 'ExpiredDealsWidget',
  components: {
    DashboardWidget,
  },
  props: {
    expired: {
      type: Object as PropType<DashboardWidgetData>,
      required: true,
    },
    currency: {
      type: Object as PropType<Currency>,
      required: true,
    },
  },
  setup(props) {
    const title = computed(() => (props.expired.count === 1 ? t('Deal') : t('Deals')));
    const formattedValue = computed(() => formatCurrency(props.expired.value, props.currency));

    return {
      title,
      formattedValue,
      DashboardWidgetHeaderColor,
      DashboardWidgetValueColor,
    };
  },
});
